export default __webpack_public_path__ + "static/media/1815.be9881f0.png";